export function AverageSpendSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/average-spend.svg'"></ng-include>`
    }
}